<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col>
        <Header
          :title="'Zamestnanci'"
          :subtitle="'V marketingu platí zásada, že treba prezentovať výhody a nie vlastnosti produktov. Pomôžte zákazníkovi vyriešiť jeho problém, splniť jeho túžbu.'"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="px-5">
        <v-data-table
          :headers="header"
          :items="employees"
          :search="search"
          :items-per-page="15"
          sort-by="name"
          class="elevation-0 transparent"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent">
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item.created="{ item }">
            <span>{{ item.created | moment("dddd, Do MMMM YYYY, HH:mm:ss") }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="primary"
                  dark
                  v-on="on"
                  @click="{{item.customerGuid}}"
                >mdi-arrow-right-bold-box</v-icon>
              </template>
              <span>EDIT NEFUNGUJE</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Header from "@/components/Header";
import { tableHeader } from "./js/employee";
export default {
  name: "Employee",
  components: { Header },
  data() {
    return {
      employees: [],
      header: tableHeader,
      search: ""
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .employeeService()
        .getEmployees()
        .then(response => {
          this.employees = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    }
  }
};
</script>
